import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/about-simpletech")({
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
